// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cf2-avatar {
  background-image: url("/assets/images/caseflo.png");
  background-size: cover;
}

mat-card {
  max-width: 600px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/maintenance/maintenance.component.scss"],"names":[],"mappings":"AAAA;EACE,mDAAA;EACA,sBAAA;AACF;;AAEA;EACE,gBAAA;AACF","sourcesContent":[".cf2-avatar {\n  background-image: url('/assets/images/caseflo.png');\n  background-size: cover;\n}\n\nmat-card {\n  max-width: 600px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
